/**
 * Snap-to-grid helpers.
 *
 * `DEFAULT_GRID_SIZE` is the sensible default grid spacing (in flow units) used
 * when a diagram does not declare its own `gridSize`.
 */

/** Default snap grid spacing in flow units. */
export const DEFAULT_GRID_SIZE = 16

/** Snap a single coordinate to the nearest grid multiple. */
export function snapToGridValue(value: number, gridSize: number): number {
  if (!gridSize || gridSize <= 0) return value
  return Math.round(value / gridSize) * gridSize
}

/**
 * Coerce an arbitrary (possibly undefined / invalid) grid size into a whole,
 * positive number, falling back to `DEFAULT_GRID_SIZE`.
 */
export function normalizeGridSize(gridSize: number | undefined | null): number {
  if (typeof gridSize !== 'number' || !Number.isFinite(gridSize) || gridSize <= 0) {
    return DEFAULT_GRID_SIZE
  }
  return Math.max(1, Math.round(gridSize))
}
